'use strict';

var React = require('react');
var FormField = require('./FormField-090113ec.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Select(props) {
    return React__default["default"].createElement(FormField.FormField, Object.assign({ type: "select" }, props));
}

function SelectOption({ children, disabled, value }) {
    return (React__default["default"].createElement("option", { disabled: disabled, value: value }, children));
}

exports.Select = Select;
exports.SelectOption = SelectOption;
